import Swal from "sweetalert2";
import "../pages/game/stageCelebration.css";

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function buildConfettiHtml() {
  return Array.from({ length: 14 }, (_, i) => {
    return `<span class="stage-celebrate__piece" style="--i:${i}"></span>`;
  }).join("");
}

/**
 * Wait for the browser to finish layout after a modal closes (avoids ResizeObserver loops).
 */
export function flushLayoutFrame() {
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(resolve);
    });
  });
}

/**
 * Navigate after celebration modal teardown so route changes don't fight Swal layout.
 */
export async function navigateAfterCelebration(navigate, path, options) {
  await flushLayoutFrame();
  navigate(path, { replace: true, ...options });
}

export function showStageCompleteCelebration({
  skip = false,
  score,
} = {}) {
  if (skip) return Promise.resolve();

  const scoreHtml =
    score != null && Number(score) > 0
      ? `<p class="stage-celebrate__score">+${escapeHtml(score)} points</p>`
      : "";

  return Swal.fire({
    html: `<div class="stage-celebrate">
      <div class="stage-celebrate__confetti" aria-hidden="true">${buildConfettiHtml()}</div>
      <div class="stage-celebrate__icon" aria-hidden="true">🏆</div>
      <h2 class="stage-celebrate__title">You did it!</h2>
      <p class="stage-celebrate__text">You've completed the game.</p>
      ${scoreHtml}
      <button type="button" class="stage-celebrate__btn" data-stage-celebrate-close>Continue</button>
    </div>`,
    showConfirmButton: false,
    showCloseButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    width: "min(92vw, 26em)",
    heightAuto: true,
    scrollbarPadding: false,
    returnFocus: false,
    customClass: {
      popup: "stage-celebrate-popup",
      htmlContainer: "stage-celebrate-popup__html",
    },
    didOpen: () => {
      Swal.getPopup()
        ?.querySelector("[data-stage-celebrate-close]")
        ?.addEventListener("click", () => Swal.close(), { once: true });
    },
  }).then(() => flushLayoutFrame());
}
